export default __webpack_public_path__ + "static/media/logo-dark.0f35ca20.svg";